import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider } from "@mui/material";
import configs from "../../../../config/config";
import { translate } from "../../../../config/localisation";

// Личная выработка исполнителя. Раньше эти цифры уходили только письмом
// (задача send_mail_task), а на стенде почта не настроена — поэтому
// показываем их прямо на странице проектов.

const STAGE_KEY = {
  annotation: "my.summary.stage.annotation",
  review: "my.summary.stage.review",
  supercheck: "my.summary.stage.supercheck",
};

const PERIOD_KEY = {
  today: "my.summary.period.today",
  week: "my.summary.period.week",
};

const Metric = ({ value, labelKey, muted }) => (
  <Box sx={{ minWidth: "104px", mr: 3 }}>
    <Typography
      sx={{
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: 1.2,
        color: muted ? "#B0651A" : "#2C2799",
      }}
    >
      {value}
    </Typography>
    <Typography sx={{ fontSize: "12px", color: "#5F5E5A" }}>
      {translate(labelKey)}
    </Typography>
  </Box>
);

const MySummary = () => {
  const [periods, setPeriods] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${configs.BASE_URL_AUTO}/users/my_summary/`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.getItem("csi_access_token")}`,
          },
        });
        const data = await res.json();
        if (!cancelled && res.ok && Array.isArray(data?.periods)) {
          setPeriods(data.periods);
        }
      } catch (e) {
        // сводка необязательна — список проектов должен открыться и без неё
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  // Менеджеру и владельцу организации сводка не положена: они не исполнители,
  // бэкенд вернёт пустые этапы — блок просто не показываем.
  const hasStages = periods?.some((p) => p.stages?.length > 0);
  if (!periods || !hasStages) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #D3D1C7",
        borderRadius: "8px",
        p: 2,
        ml: "15px",
        mr: "15px",
        mt: 2,
      }}
    >
      <Typography sx={{ fontSize: "15px", fontWeight: 600, mb: 1.5 }}>
        {translate("my.summary.title")}
      </Typography>

      {periods.map((period, pIdx) => (
        <Box key={period.period}>
          {pIdx > 0 && <Divider sx={{ my: 1.5 }} />}
          <Typography sx={{ fontSize: "13px", color: "#5F5E5A", mb: 0.75 }}>
            {translate(PERIOD_KEY[period.period])}
            {period.period === "week" ? ` (${period.start_date} — ${period.end_date})` : ""}
          </Typography>

          {period.stages.map((stage) => (
            <Box
              key={stage.stage}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                flexWrap: "wrap",
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  width: "150px",
                  pt: "4px",
                  pr: 2,
                }}
              >
                {translate(STAGE_KEY[stage.stage])}
              </Typography>
              <Metric value={stage.tasks} labelKey="my.summary.tasks" />
              <Metric value={stage.duration} labelKey="my.summary.duration" />
              <Metric value={stage.segments} labelKey="my.summary.segments" />
              {stage.returned !== undefined && (
                <Metric
                  value={stage.returned}
                  labelKey="my.summary.returned"
                  muted
                />
              )}
            </Box>
          ))}
        </Box>
      ))}
    </Paper>
  );
};

export default MySummary;
